

















import { Component, Prop, Vue } from "vue-property-decorator";
import { CzOption } from "./types";

@Component
export default class CzSegmented extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: CzOption[];
  @Prop({ default: null }) value!: any;
}
